import React, { useState, useEffect, useRef } from 'react';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

const css = `
.cc-shell { font-family: 'Inter', system-ui, sans-serif; min-height: 100vh;
  background: #0f172a; color: #e2e8f0; }
.cc-header { padding: 1rem 2rem; border-bottom: 1px solid #1e293b;
  display: flex; align-items: center; gap: 1rem; }
.cc-title { font-size: 1.25rem; font-weight: 700; }
.cc-pill { background: #1e293b; color: #94a3b8; font-size: 0.7rem;
  padding: 0.25rem 0.6rem; border-radius: 12px; letter-spacing: 0.05em;
  text-transform: uppercase; }
.cc-grid { display: grid; grid-template-columns: 280px 1fr;
  min-height: calc(100vh - 65px); }
.cc-sidebar { padding: 1rem; background: #0b1220;
  border-right: 1px solid #1e293b; }
.cc-main { padding: 1.5rem 2rem; overflow-y: auto; }
.cc-section { background: #1e293b; border-radius: 10px; padding: 1.25rem;
  margin-bottom: 1.25rem; border: 1px solid #334155; }
.cc-section h2 { font-size: 0.95rem; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.05em; color: #94a3b8;
  margin-bottom: 0.85rem; }
.cc-tabs { display: flex; gap: 0.4rem; margin-bottom: 1rem;
  flex-wrap: wrap; }
.cc-tab { background: transparent; color: #94a3b8;
  border: 1px solid #334155; padding: 0.45rem 0.85rem;
  border-radius: 6px; font-size: 0.85rem; cursor: pointer;
  font-family: inherit; }
.cc-tab.active { background: #0073EA; color: #fff; border-color: #0073EA; }
.cc-input { width: 100%; background: #0b1220; color: #e2e8f0;
  border: 1px solid #334155; border-radius: 6px;
  padding: 0.5rem 0.7rem; font-size: 0.88rem; font-family: inherit; }
.cc-input:focus { outline: 2px solid #0073EA; }
.cc-label { font-size: 0.78rem; color: #94a3b8;
  margin-bottom: 0.25rem; display: block; }
.cc-row { display: grid; grid-template-columns: 1fr 1fr;
  gap: 0.75rem; margin-bottom: 0.75rem; }
.cc-btn { background: #0073EA; color: #fff; border: none;
  padding: 0.55rem 1.1rem; border-radius: 6px;
  font-size: 0.88rem; font-weight: 600; cursor: pointer;
  font-family: inherit; }
.cc-btn:disabled { opacity: 0.5; cursor: default; }
.cc-btn.secondary { background: transparent;
  border: 1px solid #334155; color: #cbd5e1; }
.cc-drop { border: 2px dashed #334155; border-radius: 10px;
  padding: 2.5rem 1rem; text-align: center; color: #94a3b8;
  cursor: pointer; transition: all 0.2s; }
.cc-drop.active { border-color: #0073EA;
  background: rgba(0,115,234,0.06); color: #fff; }
.cc-table { width: 100%; border-collapse: collapse;
  font-size: 0.85rem; }
.cc-table th { text-align: left; padding: 0.5rem;
  background: #0b1220; color: #94a3b8;
  text-transform: uppercase; font-size: 0.7rem; letter-spacing: 0.05em; }
.cc-table td { padding: 0.55rem 0.5rem;
  border-top: 1px solid #334155; color: #e2e8f0; vertical-align: top; }
.cc-conf { font-size: 0.7rem; padding: 0.15rem 0.5rem;
  border-radius: 10px; font-weight: 600; }
.cc-conf-high { background: #14532d; color: #86efac; }
.cc-conf-medium { background: #713f12; color: #fcd34d; }
.cc-conf-low { background: #7f1d1d; color: #fca5a5; }
.cc-conf-none { background: #1e293b; color: #94a3b8; }
.cc-summary { display: grid; grid-template-columns: repeat(4,1fr);
  gap: 0.75rem; margin-bottom: 1rem; }
.cc-stat { background: #0b1220; padding: 0.85rem;
  border-radius: 8px; border: 1px solid #334155; }
.cc-stat-label { font-size: 0.7rem; color: #94a3b8;
  text-transform: uppercase; letter-spacing: 0.05em; }
.cc-stat-value { font-size: 1.5rem; font-weight: 700;
  color: #fff; margin-top: 0.25rem; }
`;

const TABS = [
  { id: 'overview', label: 'Overview' },
  { id: 'upload', label: 'Upload Documents' },
  { id: 'tenancy', label: 'Create Tenancy' },
  { id: 'landlord_property', label: 'Landlord / Property' },
  { id: 'audit', label: 'Audit Log' },
];

export default function AdminConcierge() {
  const [adminKey, setAdminKey] = useState('');
  const [authed, setAuthed] = useState(false);
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState('');
  const [context, setContext] = useState(null);
  const [tab, setTab] = useState('overview');
  const [auditRows, setAuditRows] = useState([]);

  // ----- AUTH -----
  const login = async (e) => {
    e?.preventDefault?.();
    if (!adminKey) return;
    try {
      const r = await fetch(
        `${API_BASE_URL}/api/admin/concierge/agents`,
        { headers: { 'X-Admin-Key': adminKey } });
      if (!r.ok) {
        alert('Invalid ADMIN_KEY');
        return;
      }
      const d = await r.json();
      setAgents(d.agents || []);
      setAuthed(true);
    } catch (err) {
      alert('Login failed');
    }
  };

  const loadContext = async (aid) => {
    setSelectedAgent(aid);
    if (!aid) { setContext(null); return; }
    const r = await fetch(
      `${API_BASE_URL}/api/admin/concierge/agent/${aid}/context`,
      { headers: { 'X-Admin-Key': adminKey } });
    if (r.ok) setContext(await r.json());
  };

  const loadAudit = async () => {
    const url = selectedAgent
      ? `${API_BASE_URL}/api/admin/concierge/audit?agent_id=${selectedAgent}`
      : `${API_BASE_URL}/api/admin/concierge/audit`;
    const r = await fetch(url, { headers: { 'X-Admin-Key': adminKey } });
    if (r.ok) {
      const d = await r.json();
      setAuditRows(d.audit || []);
    }
  };

  useEffect(() => {
    if (authed && tab === 'audit') loadAudit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab, selectedAgent, authed]);

  if (!authed) {
    return (
      <div className="cc-shell">
        <style>{css}</style>
        <div style={{ maxWidth: 420, margin: '6rem auto',
                      background: '#1e293b', padding: '2rem',
                      borderRadius: 10 }}>
          <div className="cc-title" style={{ marginBottom: '0.5rem' }}>
            Admin Concierge
          </div>
          <p style={{ color: '#94a3b8', fontSize: '0.85rem',
                       marginBottom: '1rem' }}>
            Owner-only tool for onboarding agents on their behalf.
          </p>
          <form onSubmit={login}>
            <label className="cc-label">ADMIN_KEY</label>
            <input
              type="password"
              className="cc-input"
              value={adminKey}
              onChange={(e) => setAdminKey(e.target.value)}
              data-testid="cc-key-input"
              autoFocus />
            <button type="submit"
                    className="cc-btn"
                    style={{ marginTop: '1rem', width: '100%' }}
                    data-testid="cc-login-btn">
              Sign in
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="cc-shell" data-testid="cc-shell">
      <style>{css}</style>
      <div className="cc-header">
        <div className="cc-title">Estatel AI Concierge</div>
        <span className="cc-pill">Admin only</span>
        <div style={{ marginLeft: 'auto', display: 'flex',
                       alignItems: 'center', gap: '0.6rem' }}>
          <label className="cc-label" style={{ margin: 0 }}>
            Agent:
          </label>
          <select
            value={selectedAgent}
            onChange={(e) => loadContext(e.target.value)}
            className="cc-input"
            style={{ width: 260 }}
            data-testid="cc-agent-select">
            <option value="">— Select agent —</option>
            {agents.map(a => (
              <option key={a.id} value={a.id}>
                {a.company_name} · {a.contact_email || ''}
              </option>
            ))}
          </select>
          <a href="/admin"
             style={{ color: '#94a3b8', fontSize: '0.8rem',
                       textDecoration: 'none' }}>
            ← Admin dashboard
          </a>
        </div>
      </div>

      <div className="cc-grid">
        <div className="cc-sidebar">
          <div className="cc-tabs" style={{ flexDirection: 'column' }}>
            {TABS.map(t => (
              <button key={t.id}
                       className={`cc-tab ${tab === t.id ? 'active' : ''}`}
                       onClick={() => setTab(t.id)}
                       disabled={t.id !== 'audit' && !selectedAgent}
                       data-testid={`cc-tab-${t.id}`}>
                {t.label}
              </button>
            ))}
          </div>
        </div>

        <div className="cc-main">
          {!selectedAgent && tab !== 'audit' && (
            <div className="cc-section">
              <p style={{ color: '#94a3b8' }}>
                Select an agent above to load their account.
              </p>
            </div>
          )}

          {selectedAgent && tab === 'overview' && context && (
            <OverviewTab context={context}
                          agentId={selectedAgent}
                          adminKey={adminKey}
                          onCompleted={() => loadContext(selectedAgent)} />
          )}

          {selectedAgent && tab === 'upload' && (
            <UploadTab agentId={selectedAgent}
                        adminKey={adminKey}
                        properties={context?.properties || []}
                        onSaved={() => loadContext(selectedAgent)} />
          )}

          {selectedAgent && tab === 'tenancy' && (
            <TenancyTab agentId={selectedAgent}
                         adminKey={adminKey}
                         landlords={context?.landlords || []}
                         properties={context?.properties || []}
                         onCreated={() => loadContext(selectedAgent)} />
          )}

          {selectedAgent && tab === 'landlord_property' && (
            <LandlordPropertyTab
              agentId={selectedAgent}
              adminKey={adminKey}
              context={context}
              onChanged={() => loadContext(selectedAgent)} />
          )}

          {tab === 'audit' && (
            <AuditTab rows={auditRows}
                       agents={agents}
                       onRefresh={loadAudit} />
          )}
        </div>
      </div>
    </div>
  );
}


function OverviewTab({ context, agentId, adminKey, onCompleted }) {
  const c = context.compliance_summary || {};
  const onboardingStatus = (context.agent || {}).onboarding_status;
  const isCompleted = onboardingStatus === 'completed';
  const isInProgress = onboardingStatus === 'concierge_in_progress';
  const completedAt = (context.agent || {}).concierge_completed_at;
  const [busy, setBusy] = React.useState(false);
  const [msg, setMsg] = React.useState(null);
  const [err, setErr] = React.useState(null);

  const markComplete = async () => {
    if (!window.confirm(
      `Mark concierge onboarding complete for ${context.agent.company_name}?\n\n`
      + 'This sets onboarding_status to "completed" on the agent account '
      + "and removes the amber onboarding banner from the agent's "
      + 'dashboard. It is an explicit action — only do this once you '
      + 'are satisfied their landlords, properties and tenancies are '
      + 'all in.'
    )) return;
    setBusy(true); setMsg(null); setErr(null);
    try {
      const r = await fetch(
        `${API_BASE_URL}/api/admin/concierge/agent/${agentId}/complete`
        + `?admin_key=${encodeURIComponent(adminKey)}`,
        { method: 'POST',
          headers: { 'X-Admin-Key': adminKey, 'Content-Type': 'application/json' },
          body: JSON.stringify({}) },
      );
      if (!r.ok) {
        const t = await r.text();
        let detail = t;
        try { detail = (JSON.parse(t)?.detail) || t; } catch { /* keep raw */ }
        setErr(detail || `Request failed (${r.status})`);
        return;
      }
      const body = await r.json();
      setMsg(body.already_completed
        ? 'Already marked complete — no change.'
        : `Concierge onboarding marked complete for ${body.company_name}. The agent's dashboard banner will disappear on next load.`);
      if (onCompleted) onCompleted();
    } catch (e) {
      setErr(e?.message || 'Network error');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {/* 2026-02 — Mark concierge onboarding complete (Option 1).
          Visible for every agent. Renders one of three states based on
          AgentClient.onboarding_status:
            - 'completed'              → green "Already complete" badge
            - 'concierge_in_progress'  → amber Mark-complete button
            - null / anything else     → grey Mark-complete button
              (still allowed — the concierge may finalise a self-onboarded
              agent if asked).
      */}
      <div className="cc-section"
           data-testid="cc-concierge-complete-block"
           style={{ background: isCompleted ? '#dcfce7' : '#fef3c7',
                     border: '1px solid '
                              + (isCompleted ? '#86efac' : '#fde68a'),
                     borderRadius: 8, padding: '0.85rem 1rem',
                     marginBottom: '1rem' }}>
        <div style={{ display: 'flex', alignItems: 'flex-start',
                       gap: 12, flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontWeight: 700,
                           color: isCompleted ? '#166534' : '#92400e' }}>
              {isCompleted
                ? '✓ Concierge onboarding complete'
                : 'Concierge onboarding ' + (isInProgress
                    ? 'in progress' : 'status: not yet started')}
            </div>
            <div style={{ fontSize: '0.85rem',
                           color: '#475569', marginTop: 4 }}>
              {isCompleted
                ? (completedAt
                    ? `Completed ${new Date(completedAt).toLocaleString('en-GB')}. The agent's dashboard banner is hidden.`
                    : 'The agent\'s dashboard banner is hidden.')
                : 'Click below once you are satisfied the agent has '
                  + 'their landlords, properties and tenancies in. '
                  + 'This is an explicit action — no auto-detection.'}
            </div>
            {msg && (
              <div data-testid="cc-concierge-complete-msg"
                   style={{ marginTop: 8, color: '#166534',
                             fontSize: '0.85rem', fontWeight: 600 }}>
                {msg}
              </div>
            )}
            {err && (
              <div data-testid="cc-concierge-complete-err"
                   style={{ marginTop: 8, color: '#7f1d1d',
                             background: '#fee2e2',
                             border: '1px solid #fca5a5',
                             borderRadius: 6,
                             padding: '0.4rem 0.6rem',
                             fontSize: '0.85rem' }}>
                {err}
              </div>
            )}
          </div>
          {!isCompleted && (
            <button onClick={markComplete}
                    disabled={busy}
                    data-testid="cc-mark-concierge-complete-btn"
                    style={{ background: '#0f172a', color: '#fff',
                              border: 'none', padding: '0.55rem 1rem',
                              borderRadius: 6, fontWeight: 600,
                              cursor: busy ? 'not-allowed' : 'pointer',
                              opacity: busy ? 0.7 : 1 }}>
              {busy ? 'Marking…' : 'Mark concierge onboarding complete'}
            </button>
          )}
        </div>
      </div>

      <div className="cc-summary">
        <div className="cc-stat">
          <div className="cc-stat-label">Landlords</div>
          <div className="cc-stat-value">{context.landlords.length}</div>
        </div>
        <div className="cc-stat">
          <div className="cc-stat-label">Properties</div>
          <div className="cc-stat-value">{context.properties.length}</div>
        </div>
        <div className="cc-stat">
          <div className="cc-stat-label">Tenants</div>
          <div className="cc-stat-value">{context.tenants.length}</div>
        </div>
        <div className="cc-stat">
          <div className="cc-stat-label">Compliance Issues</div>
          <div className="cc-stat-value">
            {(c.expired || 0) + (c.expiring_90d || 0)}
          </div>
        </div>
      </div>

      <div className="cc-section">
        <h2>Compliance breakdown</h2>
        <div style={{ display: 'flex', gap: '1.5rem',
                       flexWrap: 'wrap', fontSize: '0.85rem' }}>
          <span>EPC: {c.epc || 0}</span>
          <span>Gas Safety: {c.gas_safety || 0}</span>
          <span>EICR: {c.eicr || 0}</span>
          <span style={{ color: '#fcd34d' }}>
            Expiring (90d): {c.expiring_90d || 0}
          </span>
          <span style={{ color: '#fca5a5' }}>
            Expired: {c.expired || 0}
          </span>
        </div>
      </div>

      <div className="cc-section">
        <h2>Properties</h2>
        <table className="cc-table" data-testid="cc-property-list">
          <thead>
            <tr><th>Address</th><th>Postcode</th>
                <th>Availability</th><th>HMO</th></tr>
          </thead>
          <tbody>
            {context.properties.map(p => (
              <tr key={p.id}>
                <td>{p.address_line1}, {p.city}</td>
                <td>{p.postcode}</td>
                <td>{p.availability_status}</td>
                <td>{p.is_hmo ? 'Yes' : 'No'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}


function UploadTab({ agentId, adminKey, properties, onSaved }) {
  const [dragOver, setDragOver] = useState(false);
  const [busy, setBusy] = useState(false);
  const [staged, setStaged] = useState([]);
  const [notifyAgent, setNotifyAgent] = useState(true);
  const inputRef = useRef(null);

  const upload = async (files) => {
    if (!files || !files.length) return;
    setBusy(true);
    try {
      const fd = new FormData();
      for (const f of files) fd.append('files', f);
      const r = await fetch(
        `${API_BASE_URL}/api/admin/concierge/agent/${agentId}/upload-docs`,
        { method: 'POST',
          headers: { 'X-Admin-Key': adminKey },
          body: fd });
      const d = await r.json();
      if (!r.ok) {
        alert(d.detail || 'Upload failed');
        return;
      }
      setStaged(prev => [...prev, ...(d.staged || [])]);
    } finally {
      setBusy(false);
    }
  };

  const updateRow = (idx, patch) => {
    setStaged(prev => prev.map((s, i) =>
      i === idx ? { ...s, ...patch } : s));
  };

  const removeRow = (idx) => {
    setStaged(prev => prev.filter((_, i) => i !== idx));
  };

  const confirm = async () => {
    if (!staged.length) return;
    const docs = staged.map(s => ({
      stage_id: s.stage_id,
      property_id: s.suggested_property_id,
      doc_type: s.doc_type,
      expiry_date: s.expiry_date,
    }));
    if (docs.some(d => !d.property_id)) {
      alert('Pick a property for every staged document first.');
      return;
    }
    setBusy(true);
    try {
      const r = await fetch(
        `${API_BASE_URL}/api/admin/concierge/agent/${agentId}/confirm-docs`,
        { method: 'POST',
          headers: { 'X-Admin-Key': adminKey,
                     'Content-Type': 'application/json' },
          body: JSON.stringify({ docs, notify_agent: notifyAgent }) });
      const d = await r.json();
      if (!r.ok) {
        alert(d.detail || 'Save failed');
        return;
      }
      alert(`Saved ${d.saved.length} document(s)`
            + (d.errors.length ? `, ${d.errors.length} error(s)` : ''));
      setStaged([]);
      onSaved();
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className="cc-section">
        <h2>Bulk document upload</h2>
        <div
          className={`cc-drop ${dragOver ? 'active' : ''}`}
          onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
          onDragLeave={() => setDragOver(false)}
          onDrop={(e) => {
            e.preventDefault(); setDragOver(false);
            upload(Array.from(e.dataTransfer.files || []));
          }}
          onClick={() => inputRef.current?.click()}
          data-testid="cc-drop">
          <div style={{ fontSize: '1rem', fontWeight: 600 }}>
            Drop PDFs / images here or click to choose
          </div>
          <div style={{ fontSize: '0.8rem', marginTop: '0.4rem' }}>
            Multiple files supported. Claude classifies each one and
            matches it to a property.
          </div>
          <input type="file"
                 ref={inputRef}
                 multiple
                 style={{ display: 'none' }}
                 onChange={(e) => upload(Array.from(e.target.files || []))}
                 data-testid="cc-file-input" />
        </div>
        {busy && (
          <p style={{ color: '#94a3b8', marginTop: '0.6rem' }}>
            Processing…
          </p>
        )}
      </div>

      {staged.length > 0 && (
        <div className="cc-section">
          <h2>Review &amp; confirm ({staged.length})</h2>
          <table className="cc-table" data-testid="cc-staged-table">
            <thead>
              <tr>
                <th>File</th><th>Type</th><th>Property</th>
                <th>Expiry</th><th>Confidence</th><th />
              </tr>
            </thead>
            <tbody>
              {staged.map((s, i) => (
                <tr key={s.stage_id}>
                  <td style={{ maxWidth: 180, overflow: 'hidden',
                                 textOverflow: 'ellipsis',
                                 whiteSpace: 'nowrap' }}
                       title={s.filename}>
                    {s.filename}
                  </td>
                  <td>
                    <select
                      value={s.doc_type || 'unclassified'}
                      onChange={(e) => updateRow(i,
                        { doc_type: e.target.value })}
                      className="cc-input"
                      style={{ minWidth: 140 }}
                      data-testid={`cc-staged-type-${i}`}>
                      <option value="epc">EPC</option>
                      <option value="gas_safety">Gas Safety</option>
                      <option value="eicr">EICR</option>
                      <option value="deposit_certificate">
                        Deposit Cert
                      </option>
                      <option value="licence">Licence</option>
                      <option value="right_to_rent">Right to Rent</option>
                      <option value="tenancy_agreement">
                        Tenancy Agreement
                      </option>
                      <option value="unclassified">
                        Unclassified (review later)
                      </option>
                    </select>
                  </td>
                  <td>
                    <select
                      value={s.suggested_property_id || ''}
                      onChange={(e) => updateRow(i,
                        { suggested_property_id: e.target.value })}
                      className="cc-input"
                      style={{ minWidth: 220 }}
                      data-testid={`cc-staged-prop-${i}`}>
                      <option value="">— Pick property —</option>
                      {properties.map(p => (
                        <option key={p.id} value={p.id}>
                          {p.address_line1}, {p.postcode}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input type="date"
                            value={(s.expiry_date || '').slice(0, 10)}
                            onChange={(e) => updateRow(i,
                              { expiry_date: e.target.value })}
                            className="cc-input"
                            style={{ width: 140 }} />
                  </td>
                  <td>
                    <span className={`cc-conf cc-conf-${s.confidence}`}>
                      {s.confidence}
                    </span>
                  </td>
                  <td>
                    <button className="cc-btn secondary"
                            onClick={() => removeRow(i)}
                            data-testid={`cc-staged-remove-${i}`}>
                      ×
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ marginTop: '1rem',
                         display: 'flex', gap: '0.75rem',
                         alignItems: 'center' }}>
            <label style={{ fontSize: '0.85rem',
                             display: 'flex',
                             alignItems: 'center',
                             gap: '0.4rem',
                             color: '#94a3b8' }}>
              <input type="checkbox"
                     checked={notifyAgent}
                     onChange={(e) => setNotifyAgent(e.target.checked)}
                     data-testid="cc-notify-agent" />
              Notify agent by email
            </label>
            <button className="cc-btn"
                    onClick={confirm}
                    disabled={busy}
                    data-testid="cc-confirm-docs">
              Confirm &amp; save {staged.length} document(s)
            </button>
          </div>
        </div>
      )}
    </>
  );
}


function TenancyTab({ agentId, adminKey, landlords, properties, onCreated }) {
  const [llMode, setLlMode] = useState('existing'); // existing|new
  const [propMode, setPropMode] = useState('existing');
  const [form, setForm] = useState({
    landlord_id: '',
    new_landlord_full_name: '',
    new_landlord_email: '',
    new_landlord_phone: '',
    property_id: '',
    new_prop_address_line1: '',
    new_prop_city: '',
    new_prop_postcode: '',
    new_prop_bedrooms: 1,
    tenant_first_name: '',
    tenant_last_name: '',
    tenant_email: '',
    tenant_phone: '',
    rtr_checked: false,
    start_date: '',
    rent_amount: '',
    deposit_amount: '',
    rent_period: 'monthly',
  });
  const [busy, setBusy] = useState(false);

  const f = (k) => (e) =>
    setForm(prev => ({ ...prev,
      [k]: e.target.type === 'checkbox'
            ? e.target.checked : e.target.value }));

  const submit = async () => {
    const payload = {
      tenant: {
        first_name: form.tenant_first_name,
        last_name: form.tenant_last_name,
        email: form.tenant_email || null,
        phone: form.tenant_phone || null,
        right_to_rent_checked: form.rtr_checked,
      },
      tenancy: {
        start_date: form.start_date,
        rent_amount: parseFloat(form.rent_amount || 0),
        deposit_amount: parseFloat(form.deposit_amount || 0),
        rent_period: form.rent_period,
      },
    };
    if (llMode === 'existing') {
      payload.landlord_id = form.landlord_id;
    } else {
      payload.new_landlord = {
        full_name: form.new_landlord_full_name,
        email: form.new_landlord_email || null,
        phone_number: form.new_landlord_phone || null,
      };
    }
    if (propMode === 'existing') {
      payload.property_id = form.property_id;
    } else {
      payload.new_property = {
        address_line1: form.new_prop_address_line1,
        city: form.new_prop_city,
        postcode: form.new_prop_postcode,
        bedrooms: parseInt(form.new_prop_bedrooms || 1, 10),
      };
    }
    setBusy(true);
    try {
      const r = await fetch(
        `${API_BASE_URL}/api/admin/concierge/agent/${agentId}/full-tenancy`,
        { method: 'POST',
          headers: { 'X-Admin-Key': adminKey,
                     'Content-Type': 'application/json' },
          body: JSON.stringify(payload) });
      const d = await r.json();
      if (!r.ok) {
        alert(d.detail || 'Failed');
        return;
      }
      alert('Tenancy created.');
      onCreated();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cc-section">
      <h2>Create full tenancy</h2>

      <div className="cc-label">Landlord</div>
      <div className="cc-tabs">
        <button className={`cc-tab ${llMode === 'existing' ? 'active' : ''}`}
                onClick={() => setLlMode('existing')}>
          Use existing
        </button>
        <button className={`cc-tab ${llMode === 'new' ? 'active' : ''}`}
                onClick={() => setLlMode('new')}>
          Create new
        </button>
      </div>
      {llMode === 'existing' ? (
        <select className="cc-input"
                value={form.landlord_id}
                onChange={f('landlord_id')}
                data-testid="cc-ten-landlord">
          <option value="">— Select landlord —</option>
          {landlords.map(l => (
            <option key={l.id} value={l.id}>{l.full_name}</option>
          ))}
        </select>
      ) : (
        <div className="cc-row">
          <input className="cc-input"
                 placeholder="Full name"
                 value={form.new_landlord_full_name}
                 onChange={f('new_landlord_full_name')}
                 data-testid="cc-ten-newll-name" />
          <input className="cc-input"
                 placeholder="Email"
                 value={form.new_landlord_email}
                 onChange={f('new_landlord_email')} />
        </div>
      )}

      <div className="cc-label" style={{ marginTop: '1rem' }}>
        Property
      </div>
      <div className="cc-tabs">
        <button className={`cc-tab ${propMode === 'existing' ? 'active' : ''}`}
                onClick={() => setPropMode('existing')}>
          Use existing
        </button>
        <button className={`cc-tab ${propMode === 'new' ? 'active' : ''}`}
                onClick={() => setPropMode('new')}>
          Create new
        </button>
      </div>
      {propMode === 'existing' ? (
        <select className="cc-input"
                value={form.property_id}
                onChange={f('property_id')}
                data-testid="cc-ten-property">
          <option value="">— Select property —</option>
          {properties.map(p => (
            <option key={p.id} value={p.id}>
              {p.address_line1}, {p.postcode}
            </option>
          ))}
        </select>
      ) : (
        <>
          <input className="cc-input"
                 placeholder="Address line 1"
                 value={form.new_prop_address_line1}
                 onChange={f('new_prop_address_line1')}
                 data-testid="cc-ten-newprop-addr" />
          <div className="cc-row" style={{ marginTop: '0.5rem' }}>
            <input className="cc-input"
                   placeholder="City"
                   value={form.new_prop_city}
                   onChange={f('new_prop_city')} />
            <input className="cc-input"
                   placeholder="Postcode"
                   value={form.new_prop_postcode}
                   onChange={f('new_prop_postcode')} />
          </div>
        </>
      )}

      <div className="cc-label" style={{ marginTop: '1rem' }}>
        Tenant
      </div>
      <div className="cc-row">
        <input className="cc-input"
               placeholder="First name"
               value={form.tenant_first_name}
               onChange={f('tenant_first_name')}
               data-testid="cc-ten-tenfn" />
        <input className="cc-input"
               placeholder="Last name"
               value={form.tenant_last_name}
               onChange={f('tenant_last_name')}
               data-testid="cc-ten-tenln" />
      </div>
      <div className="cc-row">
        <input className="cc-input"
               placeholder="Email"
               value={form.tenant_email}
               onChange={f('tenant_email')} />
        <input className="cc-input"
               placeholder="Phone"
               value={form.tenant_phone}
               onChange={f('tenant_phone')} />
      </div>
      <label style={{ fontSize: '0.85rem', color: '#94a3b8',
                       display: 'flex', alignItems: 'center',
                       gap: '0.4rem' }}>
        <input type="checkbox"
               checked={form.rtr_checked}
               onChange={f('rtr_checked')} />
        Right to Rent checked
      </label>

      <div className="cc-label" style={{ marginTop: '1rem' }}>
        Tenancy terms
      </div>
      <div className="cc-row">
        <div>
          <label className="cc-label">Start date</label>
          <input type="date"
                 className="cc-input"
                 value={form.start_date}
                 onChange={f('start_date')}
                 data-testid="cc-ten-start" />
        </div>
        <div>
          <label className="cc-label">Rent (£)</label>
          <input type="number"
                 className="cc-input"
                 value={form.rent_amount}
                 onChange={f('rent_amount')}
                 data-testid="cc-ten-rent" />
        </div>
      </div>
      <div className="cc-row">
        <div>
          <label className="cc-label">Deposit (£)</label>
          <input type="number"
                 className="cc-input"
                 value={form.deposit_amount}
                 onChange={f('deposit_amount')} />
        </div>
        <div>
          <label className="cc-label">Rent period</label>
          <select className="cc-input"
                  value={form.rent_period}
                  onChange={f('rent_period')}>
            <option value="monthly">Monthly</option>
            <option value="weekly">Weekly</option>
          </select>
        </div>
      </div>

      <button className="cc-btn"
              style={{ marginTop: '1rem' }}
              onClick={submit}
              disabled={busy}
              data-testid="cc-ten-submit">
        Create tenancy on behalf of agent
      </button>
    </div>
  );
}


function LandlordPropertyTab({ agentId, adminKey, context, onChanged }) {
  const [llForm, setLLForm] = useState({
    full_name: '', email: '', phone_number: '',
    address_line1: '', address_line2: '',
    city: '', postcode: '',
  });
  const [propForm, setPropForm] = useState({
    landlord_id: '', address_line1: '', city: '',
    postcode: '', bedrooms: 1, is_hmo: false,
    availability_status: 'available',
  });
  const [busy, setBusy] = useState(false);

  const createLandlord = async () => {
    if (!llForm.full_name.trim()) {
      alert('Full name required'); return;
    }
    setBusy(true);
    try {
      const r = await fetch(
        `${API_BASE_URL}/api/admin/concierge/agent/${agentId}/landlord`,
        { method: 'POST',
          headers: { 'X-Admin-Key': adminKey,
                     'Content-Type': 'application/json' },
          body: JSON.stringify(llForm) });
      if (r.ok) {
        setLLForm({ full_name: '', email: '', phone_number: '',
                     address_line1: '', address_line2: '',
                     city: '', postcode: '' });
        onChanged();
      } else {
        const d = await r.json();
        alert(d.detail || 'Failed');
      }
    } finally { setBusy(false); }
  };

  const createProp = async () => {
    if (!propForm.address_line1.trim() || !propForm.postcode.trim()) {
      alert('Address line 1 and postcode required'); return;
    }
    setBusy(true);
    try {
      const r = await fetch(
        `${API_BASE_URL}/api/admin/concierge/agent/${agentId}/property`,
        { method: 'POST',
          headers: { 'X-Admin-Key': adminKey,
                     'Content-Type': 'application/json' },
          body: JSON.stringify({
            ...propForm,
            bedrooms: parseInt(propForm.bedrooms || 1, 10),
            landlord_id: propForm.landlord_id || null,
          }) });
      if (r.ok) {
        setPropForm({ landlord_id: '', address_line1: '', city: '',
                       postcode: '', bedrooms: 1, is_hmo: false,
                       availability_status: 'available' });
        onChanged();
      } else {
        const d = await r.json();
        alert(d.detail || 'Failed');
      }
    } finally { setBusy(false); }
  };

  return (
    <>
      <div className="cc-section">
        <h2>Add landlord</h2>
        <div className="cc-row">
          <input className="cc-input"
                 placeholder="Full name"
                 value={llForm.full_name}
                 onChange={(e) => setLLForm(
                   p => ({ ...p, full_name: e.target.value }))}
                 data-testid="cc-ll-name" />
          <input className="cc-input"
                 placeholder="Email"
                 value={llForm.email}
                 onChange={(e) => setLLForm(
                   p => ({ ...p, email: e.target.value }))} />
        </div>
        <div className="cc-row">
          <input className="cc-input"
                 placeholder="Phone"
                 value={llForm.phone_number}
                 onChange={(e) => setLLForm(
                   p => ({ ...p, phone_number: e.target.value }))} />
          <input className="cc-input"
                 placeholder="Address line 1"
                 value={llForm.address_line1}
                 onChange={(e) => setLLForm(
                   p => ({ ...p, address_line1: e.target.value }))}
                 data-testid="cc-ll-addr1" />
        </div>
        <div className="cc-row">
          <input className="cc-input"
                 placeholder="Address line 2 (optional)"
                 value={llForm.address_line2}
                 onChange={(e) => setLLForm(
                   p => ({ ...p, address_line2: e.target.value }))} />
          <input className="cc-input"
                 placeholder="City"
                 value={llForm.city}
                 onChange={(e) => setLLForm(
                   p => ({ ...p, city: e.target.value }))} />
        </div>
        <div className="cc-row">
          <input className="cc-input"
                 placeholder="Postcode"
                 value={llForm.postcode}
                 onChange={(e) => setLLForm(
                   p => ({ ...p, postcode: e.target.value }))}
                 data-testid="cc-ll-postcode" />
          <div />
        </div>
        <button className="cc-btn"
                onClick={createLandlord}
                disabled={busy}
                data-testid="cc-ll-create">
          Add landlord
        </button>
      </div>

      <div className="cc-section">
        <h2>Add property</h2>
        <p style={{ color: '#94a3b8', fontSize: '0.8rem',
                     marginTop: '-0.4rem',
                     marginBottom: '0.85rem' }}>
          Use this form for <strong>available</strong> properties (no
          tenant yet) or to record a <strong>let</strong> property
          without onboarding the tenant here.<br />
          To create a full live tenancy (landlord + property + tenant
          + tenancy terms in one go), use the <em>Create Tenancy</em>
          tab instead.
        </p>
        <div className="cc-row">
          <div>
            <label className="cc-label">Landlord (optional)</label>
            <select className="cc-input"
                    value={propForm.landlord_id}
                    onChange={(e) => setPropForm(
                      p => ({ ...p, landlord_id: e.target.value }))}
                    data-testid="cc-prop-landlord">
              <option value="">— None —</option>
              {(context?.landlords || []).map(l => (
                <option key={l.id} value={l.id}>{l.full_name}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="cc-label">Status</label>
            <select className="cc-input"
                    value={propForm.availability_status}
                    onChange={(e) => setPropForm(
                      p => ({ ...p, availability_status: e.target.value }))}
                    data-testid="cc-prop-status">
              <option value="available">Available (to let)</option>
              <option value="occupied">Let (occupied)</option>
              <option value="under_offer">Under offer</option>
            </select>
          </div>
        </div>
        <input className="cc-input"
               placeholder="Address line 1"
               style={{ marginTop: '0.5rem' }}
               value={propForm.address_line1}
               onChange={(e) => setPropForm(
                 p => ({ ...p, address_line1: e.target.value }))}
               data-testid="cc-prop-addr" />
        <div className="cc-row" style={{ marginTop: '0.5rem' }}>
          <input className="cc-input"
                 placeholder="City"
                 value={propForm.city}
                 onChange={(e) => setPropForm(
                   p => ({ ...p, city: e.target.value }))} />
          <input className="cc-input"
                 placeholder="Postcode"
                 value={propForm.postcode}
                 onChange={(e) => setPropForm(
                   p => ({ ...p, postcode: e.target.value }))} />
        </div>
        <div className="cc-row" style={{ marginTop: '0.5rem' }}>
          <input type="number"
                 className="cc-input"
                 placeholder="Bedrooms"
                 value={propForm.bedrooms}
                 onChange={(e) => setPropForm(
                   p => ({ ...p, bedrooms: e.target.value }))} />
          <label style={{ fontSize: '0.85rem',
                           color: '#94a3b8',
                           display: 'flex',
                           alignItems: 'center',
                           gap: '0.4rem' }}>
            <input type="checkbox"
                   checked={propForm.is_hmo}
                   onChange={(e) => setPropForm(
                     p => ({ ...p, is_hmo: e.target.checked }))} />
            HMO
          </label>
        </div>
        <button className="cc-btn"
                onClick={createProp}
                disabled={busy}
                data-testid="cc-prop-create">
          Add property
        </button>
      </div>
    </>
  );
}


function AuditTab({ rows, agents, onRefresh }) {
  const agentName = (aid) => {
    const a = agents.find(x => x.id === aid);
    return a ? a.company_name : (aid || '—');
  };
  return (
    <div className="cc-section">
      <h2 style={{ display: 'flex', alignItems: 'center',
                    gap: '0.6rem' }}>
        Audit log
        <button className="cc-btn secondary"
                style={{ fontSize: '0.75rem',
                          padding: '0.25rem 0.65rem' }}
                onClick={onRefresh}>
          Refresh
        </button>
      </h2>
      <table className="cc-table" data-testid="cc-audit-table">
        <thead>
          <tr>
            <th>When</th><th>Action</th><th>Agent</th>
            <th>Admin</th><th>Detail</th>
          </tr>
        </thead>
        <tbody>
          {rows.map(r => (
            <tr key={r.id}>
              <td style={{ fontSize: '0.78rem',
                            color: '#94a3b8',
                            whiteSpace: 'nowrap' }}>
                {r.created_at ? new Date(r.created_at).toLocaleString()
                              : ''}
              </td>
              <td><code>{r.action_type}</code></td>
              <td>{agentName(r.agent_client_id)}</td>
              <td style={{ color: '#94a3b8' }}>
                {r.admin_identifier}
              </td>
              <td style={{ fontFamily: 'monospace',
                            fontSize: '0.72rem',
                            color: '#94a3b8',
                            maxWidth: 380,
                            wordBreak: 'break-word' }}>
                {JSON.stringify(r.detail).slice(0, 240)}
              </td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan="5"
                     style={{ color: '#94a3b8',
                               textAlign: 'center',
                               padding: '2rem' }}>
              No audit rows yet.
            </td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
